import React from "react";
import { Mail, Phone, Clock, ShieldCheck } from "lucide-react";
import PageHeader from "@/components/PageHeader";
import EnquiryForm from "@/components/EnquiryForm";
import { CONTACT } from "@/lib/content";

const Contact = () => {
  return (
    <>
      <PageHeader
        eyebrow="Contact"
        title="Speak to Bright EOR."
        subtitle="Tell us who you&apos;d like to hire, or what you&apos;d like to understand about India EOR. We&apos;ll come back with clear next steps."
        ctaLabel=""
      />
      <section className="py-20 lg:py-28 bg-navy-50" data-testid="contact-page">
        <div className="mx-auto max-w-6xl px-6 md:px-10 lg:px-12">
          <div className="grid gap-10 lg:gap-16 lg:grid-cols-12">
            <div className="lg:col-span-5">
              <p className="text-xs uppercase tracking-[0.22em] text-aqua font-semibold">Get in touch</p>
              <h2 className="font-display mt-4 text-3xl sm:text-4xl font-semibold text-navy tracking-tight leading-[1.08]">
                UK-led support. India-based talent. One managed process.
              </h2>
              <p className="mt-5 text-[16px] text-slateink leading-relaxed">
                Whether you already have a candidate in India, or you&apos;d like help finding one, Bright EOR can support the employment structure end-to-end.
              </p>

              <div className="mt-10 space-y-5">
                <ContactRow icon={<Mail className="h-5 w-5" />} label="Email" value={<a className="hover:text-aqua transition-colors" href={`mailto:${CONTACT.email}`} data-testid="contact-email">{CONTACT.email}</a>} />
                {CONTACT.phones.map((p) => (
                  <ContactRow
                    key={p.number}
                    icon={<Phone className="h-5 w-5" />}
                    label={p.label}
                    value={
                      <a className="hover:text-aqua transition-colors" href={p.href} data-testid={`contact-phone-${p.number.replace(/\s/g, "")}`}>
                        {p.number}
                      </a>
                    }
                  />
                ))}
                <ContactRow icon={<Clock className="h-5 w-5" />} label="Hours" value={<span>Mon – Fri · UK business hours</span>} />
                <ContactRow
                  icon={<ShieldCheck className="h-5 w-5" />}
                  label="Response"
                  value={<span>We typically respond within one working day.</span>}
                />
              </div>
            </div>

            <div className="lg:col-span-7">
              <div className="rounded-3xl bg-white border border-slate-200 p-8 lg:p-10 shadow-card-soft">
                <EnquiryForm />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

const ContactRow = ({ icon, label, value }) => (
  <div className="flex items-start gap-4">
    <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-aqua/15 text-navy shrink-0">{icon}</div>
    <div>
      <p className="text-xs uppercase tracking-[0.18em] text-slatemuted">{label}</p>
      <div className="mt-0.5 text-[15px] text-navy font-medium">{value}</div>
    </div>
  </div>
);

export default Contact;
